import { render, staticRenderFns } from "./ModalMenu.vue?vue&type=template&id=61d20902"
import script from "./ModalMenu.vue?vue&type=script&lang=js"
export * from "./ModalMenu.vue?vue&type=script&lang=js"
import style0 from "./ModalMenu.vue?vue&type=style&index=0&id=61d20902&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports